import { createContext, useContext, useState } from 'react';

const normKey = (s) =>
  s ? s.toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').trim() : '';

const PRIZE_LABELS_EN = {
  'bouteille nature power': 'Nature Power Bottle',
  'bouteille reaktor nature power': 'Reaktor Nature Power Bottle',
  'bouteille': 'Bottle',
  'casquette large bord nature power': 'Nature Power Wide Brim Cap',
  'casquette large bord': 'Wide Brim Cap',
  'casquette': 'Cap',
  'polo nature power': 'Nature Power Polo',
  'polo': 'Polo',
  'bloc note nature power': 'Nature Power Notebook',
  'bloc notes nature power': 'Nature Power Notebook',
  'bloc note': 'Notebook',
  'bloc notes': 'Notebook',
};

const T = {
  fr: {
    // Login
    username: "Nom d'utilisateur",
    password: 'Mot de passe',
    login: 'Se connecter',
    loggingIn: 'Connexion...',
    loginError: 'Erreur lors de la connexion',
    // Hostess – chargement & session
    loading: 'CHARGEMENT...',
    noActiveSession: 'Aucune session active',
    noActiveSessionDesc: "Il n'y a pas de session de jeu active pour votre point de vente.",
    refresh: 'Actualiser',
    loggedAs: 'Connecté en tant que',
    session: 'Session',
    pdv: 'PDV',
    schedule: 'Horaires',
    // Hostess – formulaire
    newParticipant: 'Nouveau Participant',
    registerClient: 'Enregistrez un client pour le jeu',
    photoTicket: '1. Photo du ticket',
    takePhoto: 'Prendre une photo',
    photoOk: 'Photo OK',
    deletePhotoConfirm: 'Supprimer cette photo ?',
    nameLabel: '2. Nom',
    phoneLabel: '3. Téléphone',
    namePlaceholder: 'Ex: Jean Dupont',
    bottlesLabel: '4. Bouteilles achetées',
    bottlesHint: '(2 bouteilles = 1 tour, dont ≥1 Nature Power)',
    otherReaktor: 'Autres Reaktor',
    gameModeLabel: '5. Mode de jeu',
    sendToClient: 'Envoyer au client',
    playOnMobile: 'Sur ce mobile',
    scan: 'Scanner',
    playDirect: 'Jouer Direct',
    // Hostess – validation
    fillName: 'Veuillez remplir le nom',
    fillPhone: 'Veuillez remplir le numéro de téléphone',
    invalidPhone: 'Numéro invalide. Format attendu : 6XXXXXXXX (9 chiffres) (Cameroun).',
    needBottles: 'Il faut au moins 2 bouteilles Reaktor 0,5L dont au moins 1 bouteille Nature Power',
    needPhoto: 'Veuillez prendre une photo du ticket de caisse',
    registered: 'Participant enregistré !',
    tokenError: 'Erreur : token de jeu non généré',
    redirecting: 'Participant enregistré ! Redirection...',
    loadError: 'Erreur lors du chargement de la session',
    registerError: "Erreur lors de l'enregistrement",
    // Hostess – récap bouteilles
    total: 'Total',
    bottle: 'bouteille',
    bottlePlural: 'bouteilles',
    turnOf: 'tour',
    turnPlural: 'tours',
    gameOf: 'de jeu',
    atLeastOneNP: 'au moins 1 bouteille Nature Power requise',
    minTwo: 'minimum 2 bouteilles requis',
    // QR modal
    qrTitle: 'QR Code de Jeu',
    qrDesc: 'Le client doit scanner ce QR code pour accéder à la carte à gratter',
    testLink: 'Tester le lien',
    close: 'Fermer',
    // Login – titre
    scratchCardTitle: 'CARTE À GRATTER',
    // Game
    loadingCard: 'Chargement de votre carte à gratter...',
    error: 'Erreur',
    alreadyUsed: 'Ce lien a déjà été utilisé. Veuillez contacter une hôtesse.',
    expired: 'Ce lien a expiré. Veuillez contacter une hôtesse.',
    tokenVerifyError: 'Erreur lors de la vérification du token',
    scratchTitle: 'Grattez votre carte',
    scratchSubtitle: 'Utilisez votre doigt pour révéler votre lot !',
    cardLabel: 'Carte',
    cardOf: 'sur',
    cardsRemaining: 'restantes',
    lastCard: 'Dernière !',
    preparingNext: 'Préparation de la prochaine carte...',
    revealedPrizes: 'Vos lots révélés',
    congratulations: 'Félicitations !',
    youWon: 'Vous avez gagné',
    lot: 'lot',
    lotPlural: 'lots',
    presentCodes: 'Présentez vos codes à une hôtesse',
    tooLate: 'Dommage !',
    noWin: "Vous n'avez pas gagné cette fois-ci.",
    tryAgain: 'Achetez plus de bouteilles et retentez votre chance !',
    back: 'Retour',
    codeLabel: 'Code',
    // ScratchCard
    loseTitle: 'Orlala dommage !',
    loseSub: 'Achetez de nouveau des bouteilles et retentez votre chance',
    keepScratching: 'Continuez à gratter...',
    loseLabel: 'Réessayez',
  },
  en: {
    // Login
    username: 'Username',
    password: 'Password',
    login: 'Log in',
    loggingIn: 'Logging in...',
    loginError: 'Login error',
    // Hostess – loading & session
    loading: 'LOADING...',
    noActiveSession: 'No active session',
    noActiveSessionDesc: 'There is no active game session for your point of sale.',
    refresh: 'Refresh',
    loggedAs: 'Logged in as',
    session: 'Session',
    pdv: 'POS',
    schedule: 'Schedule',
    // Hostess – form
    newParticipant: 'New Participant',
    registerClient: 'Register a customer for the game',
    photoTicket: '1. Receipt photo',
    takePhoto: 'Take a photo',
    photoOk: 'Photo OK',
    deletePhotoConfirm: 'Delete this photo?',
    nameLabel: '2. Name',
    phoneLabel: '3. Phone',
    namePlaceholder: 'Ex: John Smith',
    bottlesLabel: '4. Bottles purchased',
    bottlesHint: '(2 bottles = 1 turn, including ≥1 Nature Power)',
    otherReaktor: 'Other Reaktor',
    gameModeLabel: '5. Play mode',
    sendToClient: 'Send to customer',
    playOnMobile: 'On this mobile',
    scan: 'Scan',
    playDirect: 'Play Direct',
    // Hostess – validation
    fillName: 'Please fill in the name',
    fillPhone: 'Please fill in the phone number',
    invalidPhone: 'Invalid number. Expected format: 6XXXXXXXX (9 digits, Cameroon).',
    needBottles: 'At least 2 Reaktor 0.5L bottles required, including at least 1 Nature Power',
    needPhoto: 'Please take a photo of the receipt',
    registered: 'Participant registered!',
    tokenError: 'Error: game token not generated',
    redirecting: 'Participant registered! Redirecting...',
    loadError: 'Error loading session',
    registerError: 'Error during registration',
    // Hostess – bottles summary
    total: 'Total',
    bottle: 'bottle',
    bottlePlural: 'bottles',
    turnOf: 'turn',
    turnPlural: 'turns',
    gameOf: '',
    atLeastOneNP: 'at least 1 Nature Power bottle required',
    minTwo: 'minimum 2 bottles required',
    // QR modal
    qrTitle: 'Game QR Code',
    qrDesc: 'The customer must scan this QR code to access the scratch card',
    testLink: 'Test link',
    close: 'Close',
    // Login – titre
    scratchCardTitle: 'SCRATCH CARD',
    // Game
    loadingCard: 'Loading your scratch card...',
    error: 'Error',
    alreadyUsed: 'This link has already been used. Please contact a hostess.',
    expired: 'This link has expired. Please contact a hostess.',
    tokenVerifyError: 'Error verifying the token',
    scratchTitle: 'Scratch your card',
    scratchSubtitle: 'Use your finger to reveal your prize!',
    cardLabel: 'Card',
    cardOf: 'of',
    cardsRemaining: 'remaining',
    lastCard: 'Last one!',
    preparingNext: 'Preparing the next card...',
    revealedPrizes: 'Your revealed prizes',
    congratulations: 'Congratulations!',
    youWon: 'You won',
    lot: 'prize',
    lotPlural: 'prizes',
    presentCodes: 'Show your codes to a hostess',
    tooLate: 'Too bad!',
    noWin: "You didn't win this time.",
    tryAgain: 'Buy more bottles and try again!',
    back: 'Back',
    codeLabel: 'Code',
    // ScratchCard
    loseTitle: 'Oh no, too bad!',
    loseSub: 'Buy new bottles and try your luck again',
    keepScratching: 'Keep scratching...',
    loseLabel: 'Try Again',
  },
};

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem('rnp_lang') || 'fr');

  const changeLang = (l) => {
    localStorage.setItem('rnp_lang', l);
    setLang(l);
  };

  const t = (key) => T[lang]?.[key] ?? T.fr[key] ?? key;

  const tPrize = (label) => {
    if (!label || lang === 'fr') return label;
    return PRIZE_LABELS_EN[normKey(label)] || label;
  };

  return (
    <LanguageContext.Provider value={{ lang, setLang: changeLang, t, tPrize }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);

const G = '#00C060';

export const LangToggle = () => {
  const { lang, setLang } = useLanguage();
  return (
    <div style={{ display: 'flex', background: 'rgba(255,255,255,0.12)', borderRadius: '6px', overflow: 'hidden', border: '1px solid rgba(255,255,255,0.3)' }}>
      {['fr', 'en'].map(l => (
        <button key={l} onClick={() => setLang(l)} style={{
          background: lang === l ? G : 'transparent',
          color: '#fff',
          border: 'none',
          padding: '4px 10px',
          fontSize: '11px',
          fontWeight: 700,
          cursor: 'pointer',
          textTransform: 'uppercase',
          letterSpacing: '0.5px',
        }}>
          {l}
        </button>
      ))}
    </div>
  );
};
